import { LinearProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import StageErrorAlert from "./StageErrorAlert";

const preparationPhases = new Set(["accepted", "source", "scope", "pin", "conflicts", "preflight", "references", "saving"]);
const executionPhases = new Set(["dispatch", "cloud", "edge"]);
const journalPhases = new Set(["prepared", "commit_pending", "committed", "dispatching", "dispatched", "interrupted", "rejected", "accepted", "unknown"]);

/** Only reports persisted preparation or execution facts. Never claims target content from an accepted request. */
export default function StageRequestProgress({ request, preparation, compact = false }) {
  const { t } = useTranslation("freigabe");
  const confirming = preparation?.status === "completed" && request?.status === "pending";
  const preparing = preparation?.status === "preparing" || confirming;
  const failed = preparation?.status === "failed" || request?.status === "failed";
  const active = ["queued", "running"].includes(request?.status);
  const unknown = request?.status === "unknown";
  if (!preparing && !failed && !active && !unknown) return null;
  const phase = preparing && preparationPhases.has(preparation.phase) ? preparation.phase
    : active && request?.execution?.phase === "edge" ? "edge"
      : active && journalPhases.has(request?.progress?.phase) ? `journal.${request.progress.phase}`
      : active && executionPhases.has(request?.execution?.phase) ? request.execution.phase : null;
  return <Stack component={compact ? "span" : "div"} spacing={0.75} sx={{ width: "100%", minWidth: 0 }}>
    <Typography component="span" variant="body2" role="status" aria-live="polite"
      sx={{ color: `var(--${failed || unknown ? "warning" : "accent"})`, fontWeight: 600, overflowWrap: "anywhere" }}>
      {confirming ? t("stageBranches.progress.confirming") : preparing ? t(`stageBranches.progress.${preparation.action === "approve" ? "approving" : "requesting"}`)
        : failed ? t(preparation?.status === "failed" ? "stageBranches.progress.failed" : "promotion.status.failed") : t(`promotion.status.${request.status}`)}
    </Typography>
    {(preparing || active) && <LinearProgress component={compact ? "span" : "div"} aria-label={t("stageBranches.cell.progress")} sx={{ width: "100%" }}/>}
    {phase && <Typography component="span" variant="body2" sx={{ color: "var(--text-2)", overflowWrap: "anywhere" }}>
      {t(`stageBranches.progress.phases.${phase}`)}
    </Typography>}
    {failed && !compact && <StageErrorAlert error={preparation?.status === "failed" ? preparation.error : request?.execution?.error} title={t("promotion.status.failed")}/>}
  </Stack>;
}
